export default __webpack_public_path__ + "static/media/female_kid.038c5a58.png";